module.exports = __webpack_public_path__ + "img/tab_item_sel.ce0386ab.png";